import React from 'react';
import Demo from '../Demo/Demo';
import { steps } from '../Data/Data';
import './HowItWorks.css';

const StepHead = ({ n, title }) => (
    <div className="step-head">
        <span className="step-num" aria-hidden="true">{n}</span>
        <h3><span className="visually-hidden">Step {n}: </span>{title}</h3>
    </div>
);

const HowItWorks = () => {
    const { setup, voters, chair } = steps;
    return (
        <>
            <section className="section how" id="how-it-works">
                <div className="container">
                    <header className="how-intro">
                        <h2>{steps.title}</h2>
                        <p className="lead">{steps.intro}</p>
                    </header>

                    <article className="step step-setup">
                        <div className="step-text">
                            <StepHead n={1} title={setup.title} />
                            <p>{setup.body}</p>
                            <ul className="ticks">
                                {setup.points.map((p) => <li key={p}>{p}</li>)}
                            </ul>
                        </div>
                        <div className="setup-card">
                            <img src={setup.card} alt={setup.cardAlt} width="440" height="765" loading="lazy" />
                        </div>
                    </article>

                    <article className="step step-voters">
                        <div className="step-text">
                            <StepHead n={2} title={voters.title} />
                            <p>{voters.body}</p>
                            <dl className="voter-points">
                                {voters.points.map((p) => (
                                    <div key={p.title}>
                                        <dt>{p.title}</dt>
                                        <dd>{p.text}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                        <Demo demo={voters.demo} />
                    </article>
                </div>
            </section>

            <section className="section chair" id="chair">
                <div className="container">
                    <div className="chair-head">
                        <StepHead n={3} title={chair.title} />
                        <p>{chair.body}</p>
                    </div>
                    <ul className="chair-facts">
                        {chair.facts.map((f) => <li key={f}>{f}</li>)}
                    </ul>
                    <Demo demo={chair.demo} className="chair-demo" />
                </div>
            </section>
        </>
    );
};

export default HowItWorks;
